import { render, staticRenderFns } from "./PdvCallDelivery.vue?vue&type=template&id=281e027a&scoped=true"
import script from "./PdvCallDelivery.vue?vue&type=script&lang=js"
export * from "./PdvCallDelivery.vue?vue&type=script&lang=js"
import style0 from "./PdvCallDelivery.vue?vue&type=style&index=0&id=281e027a&prod&lang=css"
import style1 from "./PdvCallDelivery.vue?vue&type=style&index=1&id=281e027a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e027a",
  null
  
)

export default component.exports